<template>
    <div style="width:100%">
        <ul class="orgstruck-list">
            <!-- 上级公司 -->
            <li v-for="parentCom in parentComs" class="orgstruck-item">
                <div class="com-first" @click="switchComBlock(parentCom.id)">
                    <i class="icon iconfont icon-com font-gray3"></i>
                    <span>{{ parentCom.name }}</span>
                    <i class="icon iconfont arrow" :class="{'icon-down' : !parentCom.expanded, 'icon-up' : parentCom.expanded}"></i>
                </div>
                <div class="post-third" :class="{'display-none' : !parentCom.expanded, 'display-block' :parentCom.expanded }">
                    <div class="post-item">
                        <div v-for="comPost in parentCom.comRoleList" class="name" :class="{active : isSelected(comPost.id)}" @click="asSelected(comPost)">
                            <i class="icon iconfont icon-post font-gray3"></i>
                            <span :title="comPost.comName + ' - ' + comPost.name">{{ comPost.comName }} - {{ comPost.name }}</span>
                        </div>
                    </div>
                </div>
            </li>
            <!-- 指定公司 -->
            <li class="orgstruck-item" v-if="assignCom.id != null">
                <div class="com-first" @click="switchComBlock(assignCom.id)">
                    <i class="icon iconfont icon-com font-gray3"></i>
                    <span>{{ assignCom.name }} </span>
                    <i class="icon iconfont arrow" :class="{'icon-down' : !assignCom.expanded, 'icon-up' : assignCom.expanded}"></i>
                </div>
                <div class="post-third" :class="{'display-none' : !assignCom.expanded, 'display-block' :assignCom.expanded }">
                    <div class="post-item">
                        <div v-for="comPost in assignCom.comRoleList" class="name" :class="{active : isSelected(comPost.id)}" @click="asSelected(comPost)">
                            <i class="icon iconfont icon-post font-gray3"></i>
                            <span :title="comPost.comName + ' - ' + comPost.name">{{ comPost.comName }} - {{ comPost.name }}</span>
                        </div>
                    </div>
                </div>
            </li>
            <!-- 本公司 -->
            <li class="orgstruck-item">
                <div class="com-first" @click="switchComBlock(ctxCom.id)">
                    <i class="icon iconfont icon-com font-gray3"></i>
                    <span>{{ ctxCom.bizUnitName }} （本公司）</span>
                    <i class="icon iconfont arrow" :class="{'icon-down' : !ctxCom.expanded, 'icon-up' : ctxCom.expanded}"></i>
                </div>
                <div class="post-third" :class="{'display-none' : !ctxCom.expanded, 'display-block' :ctxCom.expanded }">
                    <div class="post-item">
                        <div v-for="comPost in ctxCom.comRoleList" class="name" :class="{active : isSelected(comPost.id)}" @click="asSelected(comPost)">
                            <i class="icon iconfont icon-post font-gray3"></i>
                            <span :title="comPost.comName + ' - ' + comPost.name">{{ comPost.comName }} - {{ comPost.name }}</span>
                        </div>
                    </div>
                </div>
            </li>
            <!-- 指定公司2 -->
            <li class="orgstruck-item" v-if="assignCom2.id != null">
                <div class="com-first" @click="switchComBlock(assignCom2.id)">
                    <i class="icon iconfont icon-com font-gray3"></i>
                    <span>{{ assignCom2.name }}</span>
                    <i class="icon iconfont arrow" :class="{'icon-down' : !assignCom2.expanded, 'icon-up' : assignCom2.expanded}"></i>
                </div>
                <div class="post-third" :class="{'display-none' : !assignCom2.expanded, 'display-block' :assignCom2.expanded }">
                    <div class="post-item">
                        <div v-for="comPost in assignCom2.comRoleList" class="name" :class="{active : isSelected(comPost.id)}" @click="asSelected(comPost)">
                            <i class="icon iconfont icon-post font-gray3"></i>
                            <span :title="comPost.comName + ' - ' + comPost.name">{{ comPost.comName }} - {{ comPost.name }}</span>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <!-- 审批岗位人员信息 -->
        <div class="form-group top">
            <div class="form-label">
                <label>选择审核人</label>
            </div>
            <div class="form-value width-3x ">
                <ul class="orgstruck-list" v-if="postStaffList.length > 0">
                    <li class="orgstruck-item">
                        <div class="post-third">
                            <div class="post-item">
                                <div class="name" v-for="postStaff in postStaffList" :class="{active : isSelectedPostStaff(postStaff.id)}" @click="postStaffSelected(postStaff)">
                                    <span>{{ postStaff.name }}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox } from '../../app.vues'
import merchtAllApi from '../../api/merchtAll'
import retailerApi from '../../api/retailer'
import { getUserScopeEntity } from '../index'

export default {
    name: 'swb-com-action-post-select',
    desc: '选择具有操作权限的岗位',
    props: {
        rescUrl: {
            //目标资源url
            type: String
        },
        action: {
            //目标操作（代码）
            type: String
        },
        initPostId: {
            //初始目标操作岗位id
            type: Number,
            default: null
        },
        useParents: {
            //是否使用上级公司
            type: Boolean,
            default: false
        },
        expandedParents: {
            //是否默认打开上级公司
            type: Boolean,
            default: false
        },
        headComFlag: {
            //是否使用上级公司
            type: Boolean,
            default: false
        },
        assignComId: {
            //指定公司id
            type: Number,
            default: null
        },
        assignComId2: {
            //指定公司id
            type: Number,
            default: null
        },
        showAuditStaff: {
            // 会否显示审核人
            type: Number,
            default: false
        },
        auditorStaffId: {
            //指定最后一次审核人
            type: Number,
            default: null
        }
    },
    data() {
        return {
            ctxCom: {},
            assignCom: {},
            assignCom2: {},
            //
            parentComs: [],
            //选中的信息
            postId: null,
            postName: null,
            departId: null,
            departName: null,
            comId: null,
            comName: null,
            comLevel: null,
            //
            postStaffList: [],
            defaultAuditorStaffId: null,
            selectPostStaff: {}
        };
    },
    created() {
        let userScope = getUserScopeEntity();
        let comIdX = userScope.bizUnitId;
        //获取当前公司的信息
        if(Utils.isTrue(this.headComFlag)) {
            // 获取总部公司信息
            comIdX = userScope.comId1;
            this.getRetailerComId(userScope.comId1, null);
        } else {
            this.ctxCom = {
                id: userScope.comId,
                bizUnitId: userScope.bizUnitId,
                name: userScope.comName,
                bizUnitName: userScope.bizUnitName,
                level: userScope.comLevel,
                //=> depart { id, name , roles[{..., comName, comLevel}] }
//                    departList: [],
                //数据是否已获取标记
                dataFetched: false,
                //是否展开
                expanded: true
            };
            //根据需要获取上级公司列表
            if(this.useParents && this.ctxCom.level > 1) {
                this.fetchParentComList();
            }
            this.fetchComPostList(userScope.comId, userScope.bizUnitId);
        }
        if(!Utils.isNoB(this.assignComId) && this.assignComId != comIdX) {
            this.getRetailerComId(this.assignComId, 'assign');
        }
        if(!Utils.isNoB(this.assignComId2) && this.assignComId2 != comIdX && this.assignComId2 != this.assignComId) {
            this.getRetailerComId(this.assignComId2, 'assign2');
        }
        // 记录最后一次审批人默认值 - 可清除
        if(!Utils.isNoB(this.auditorStaffId)) {
            this.defaultAuditorStaffId = this.auditorStaffId;
        }
    },

    methods: {
        // 是否总部直接审核
        getRetailerComId(comId, assignType) {
            let self = this;
            retailerApi.getRetailerCom({comId: comId}, function (result) {
                if(result.type == 'info') {
                    let retailerCom = result.data;
                    let resultCom = {
                        id: retailerCom.id,
                        bizUnitId: retailerCom.bizUnitId,
                        name: retailerCom.name,
                        bizUnitName: retailerCom.bizUnitName,
                        level: retailerCom.level,
                        //=> depart { id, name , roles[{..., comName, comLevel}] }
//                            departList: [],
                        //数据是否已获取标记
                        dataFetched: false,
                        //是否展开
                        expanded: true
                    };
                    if(assignType == null) {
                        self.ctxCom = Utils.merge({}, resultCom);
                    } else if(assignType == 'assign') {
                        self.assignCom = Utils.merge({}, resultCom);
                    } else if(assignType == 'assign2') {
                        self.assignCom2 = Utils.merge({}, resultCom);
                    }
                    self.fetchComPostList(retailerCom.id, retailerCom.bizUnitId);
                } else {
                    MsgBox.warning(result.data);
                }
            });
        },
        findComById(comId) {
            let targetCom = null;
            //
            if(comId == this.ctxCom.id) {
                //本公司
                targetCom = this.ctxCom;
            } else if(this.assignCom.id != null && comId == this.assignCom.id) {
                targetCom = this.assignCom;
            } else if(this.assignCom2.id != null && comId == this.assignCom2.id) {
                targetCom = this.assignCom2;
            } else {
                //上级公司
                targetCom = this.parentComs.find(function (com) {
                    return com.id == comId;
                });
            }
            //
            return targetCom;
        },
        //恢复初始岗位id的选择状态
        initCtxPostIdSelection(assignType) {
            let initPostId = this.initPostId;
            if(initPostId != null) {
                let comRoleList = [];
                if(assignType == null) {
                    comRoleList = this.ctxCom.comRoleList || [];
                } else if(assignType == 'assign') {
                    comRoleList = this.assignCom.comRoleList || [];
                } else if(assignType == 'assign2') {
                    comRoleList = this.assignCom2.comRoleList || [];
                } else if(assignType == 'parent') {
                    let parentComs = this.parentComs || [];
                    for(let i = 0; i < parentComs.length; i++) {
                        let parentCom = parentComs[i];
                        comRoleList = parentCom.comRoleList || [];
                        let initPost = comRoleList.find(function (item) {
                            return item.id == initPostId;
                        });
                        if(initPost != null) {
                            this.asSelected(initPost);
                        }
                    }
                }
                if(assignType != 'parent') {
                    let initPost = comRoleList.find(function (item) {
                        return item.id == initPostId;
                    });
                    if(initPost != null) {
                        this.asSelected(initPost);
                    }
                }
            }
        },
        //获取公司岗位列表
        fetchComPostList(comId, bizUnitId) {
            comId = comId || this.ctxCom.id;
            bizUnitId = bizUnitId || this.ctxCom.bizUnitId;
            //
            let postData = {};
            postData.comId = comId;
            postData.bizUnitId = bizUnitId;
            postData.rescUrl = this.rescUrl;
            postData.action = this.action;

            let self = this;
            //
            merchtAllApi.getComRoleListByContext(postData, function (result) {
                if(result.type == 'info') {
                    let comRoleList = result.data || [];
                    //
                    let targetCom = self.findComById(comId);
                    //
                    targetCom.dataFetched = true;
                    self.$set(targetCom, 'comRoleList', comRoleList)
                    //
                    if(comId == self.ctxCom.id) {
                        self.initCtxPostIdSelection(null);
                    } else if(comId == self.assignCom.id) {
                        self.initCtxPostIdSelection('assign');
                    } else if(comId == self.assignCom2.id) {
                        self.initCtxPostIdSelection('assign2');
                    } else {
                        self.initCtxPostIdSelection('parent');
                    }
                } else {
                    MsgBox.warning('获取岗位信息失败' + (result.message || ''));
                }
            });

        },
        //获取上级公司列表
        fetchParentComList() {
            let self = this;
            //
            merchtAllApi.getParentComListByContext({
                comId: self.ctxCom.bizUnitId
            }, function (result) {
                if(result.type == 'info') {
                    let parentComs = result.data || [];
                    //初始化
                    parentComs.forEach(function (com) {
                        com.dataFetched = false;
                        com.expanded = Utils.isTrue(self.expandedParents);
                        if(Utils.isTrue(self.expandedParents)) {
                            self.fetchComPostList(com.id, com.bizUnitId);
                        }
                    });
                    //
                    self.parentComs = parentComs;
                    //
                    //console.log('------- 上级公司 ------');
                    //console.log(self.parentComs);
                } else {
                    MsgBox.warning('获取上级公司信息失败' + (result.message || ''));
                }
            });
        },
        //切换公司块
        switchComBlock(comId) {
            let targetCom = this.findComById(comId);
            //
            targetCom.expanded = !targetCom.expanded;
            //
            if(targetCom.expanded && !targetCom.dataFetched) {
                this.fetchComPostList(targetCom.id, targetCom.bizUnitId);
            }
        },
        //判断是否选中状态
        isSelected(postId) {
            return this.postId == postId;
        },
        //设置为选中状态
        asSelected(post) {
            this.postId = post.id;
            this.postName = post.name;
            this.comId = post.comId;
            this.comName = post.comName;
            this.comLevel = post.comLevel;
            this.bizUnitId = post.bizUnitId;
            this.notityPostChange();
        },
        // 岗位切换
        notityPostChange: function () {
            this.selectPostStaff = {};
            this.$emit('notity-post-change', this.postId);
            //
            this.getPostStaffList(this.postId);
        },
        // 获取岗位人员信息
        getPostStaffList: function (postId) {
            let self = this;
            self.postStaffList = [];
            let theLoad = MsgBox.loading('正在获取审批人员信息...');
            retailerApi.getComRoleRefStaffList({roleId: postId}, function (result) {
                theLoad.close();
                if(result.type == 'info') {
                    let postStaffList = Utils.merge([], result.data || []);
                    self.postStaffList = postStaffList;
                    // 回显最后一次审批人
                    if(!Utils.isNoB(self.defaultAuditorStaffId)) {
                        // 回显最后一次审批人 auditorStaffId
                        let staffIds = postStaffList.pluck('id');
                        if(staffIds.indexOf(self.defaultAuditorStaffId) >= 0) {
                            let postStaffMap = postStaffList.toMap('id');
                            self.selectPostStaff = Utils.merge({}, postStaffMap[self.defaultAuditorStaffId]);
                        } else {
                            self.defaultAuditorStaffId = null;
                        }
                    }
                } else if(result.type == 'error') {
                    MsgBox.error(result.message, result.errid);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 选择岗位人员
        postStaffSelected: function (postStaff) {
            if(!Utils.isNoB(this.selectPostStaff.id) && this.selectPostStaff.id == postStaff.id) {
                this.selectPostStaff = {};
            } else {
                this.selectPostStaff = Utils.merge({}, postStaff);
            }
        },
        isSelectedPostStaff: function (staffId) {   // 是否选中审批人员
            return this.selectPostStaff.id == staffId;
        },
        //结果数据
        getResultData() {
            return {
                postId: this.postId,
                postName: this.postName,
                comId: this.comId,
                comName: this.comName,
                comLevel: this.comLevel,
                bizUnitId: this.bizUnitId,
                auditorStaffId: this.selectPostStaff.id || null,
                auditorName: this.selectPostStaff.name || null
            };
        }
    }

}

</script>



// WEBPACK FOOTER //
// src/compo/merchant/ComActionPostSelect.vue